<router-outlet></router-outlet>

